<template>
  <content-section :title="title" :background_color="sass('selected')">
    <div class="checkin-online-alert">
      <p v-if="checkin_required" class="d-flex flex-column">
        <span>
          24 ore prima della partenza ricorda di fare il check-in online
          sul sito della compagnia aerea e di scaricare le carte
          d’imbarco.
        </span>
        <span>
          Attenzione! Prendi nota di queste credenziali con cui effettuare
          l’accesso:
        </span>
      </p>
      <p v-else>
        Questo documento e il codice riportato in questa email non ti
        danno diritto all'imbarco. Per effettuare l'imbarco devi
        effettuare il check-in online prima della partenza. Il check-in
        online va obbligatoriamente effettuato sul sito della compagnia
        aerea nei termini e nelle modalità indicate sul sito stesso. Ti
        invitiamo a visitare e consultare il sito della compagnia aerea
        con attenzione
      </p>
      <p class="d-flex flex-column">
        <span class="d-flex" style="gap: 5px">
          <strong>Numero di prenotazione:</strong>
          <strong>{{ carrier_reference }}</strong>
        </span>
        <span v-if="checkin_required" class="d-flex" style="gap: 5px">
          <strong>Mail:</strong>
          <strong>{{ email_pnr }}</strong>
        </span>
        <span v-else class="d-flex" style="gap: 5px">
          <strong>Cognome:</strong>
          <strong>{{ contact_name_surname }}</strong>
        </span>
      </p>
      <p v-if="checkin_required">
        Fare il chekin online è semplice: entra nella tua area riservata e
        segui le istruzioni della compagnia. Per dubbi o assistenza siamo a
        disposizione.
      </p>
    </div>
  </content-section>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "checkin-online-alert",

  components: {
    "content-section": ContentSection,
  },

  props: {
    // codice/numero di prenotazione presso la compagnia (carrierReference)
    carrier_reference: {
      type: String,
      default: "",
    },
    // email associata al PNR per il check-in
    email_pnr: {
      type: String,
      default: "",
    },
    // nominativo con cui accedere sul sito della compagnia (caso GDS)
    contact_name_surname: {
      type: String,
      default: "",
    },
    // la compagnia richiede il check-in online (cancellara invia checkinOnlineInfo)
    checkin_required: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      let title = "Check-in e Carta d'Imbarco";
      if (this.checkin_required) {
        title = "Fai il check-in online";
      }
      return title;
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkin-online-alert {
    margin-top: $grid-gutter-width * 2 / 3;
    line-height: normal;
    font-size: 14px;

    p:last-child {
      margin-bottom: 0;
    }
  }
</style>
